import { Helmet } from 'react-helmet-async';
import React from 'react';

import requireAuth from '../../../../lib/requireAuth.jsx';
import withRouterParams from '../../../../lib/withRouterParams.jsx';

import OrgSurveySettingsFormContainer from '../../../../containers/organizations/Settings/OrgSurveyFormContainer.jsx';

const SurveySettings = ({ templateId, slug }) => (
  <>
    <Helmet>
      <title>Edit Feedback Form Template | ChangeSync</title>
    </Helmet>
    <OrgSurveySettingsFormContainer slug={slug} edit templateId={templateId} />
  </>
);

export default requireAuth(withRouterParams(SurveySettings));
